import moment from "moment";
import { LocalStorageUtils } from "../../helpers/LocalStorage";
import { findIndex, startCase, toLower } from "lodash";
export const isPasswordValid = (password: string) => {
  let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(?!.*\s).{8,}$/;
  const valid = passwordRegex.test(password);
  return valid;
};

export const isEmailValid = (email: string) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const DecryptToken = async (token: string) => {
  var base64Url = null;
  let tokenArr = token.split(".");
  console.log({ token });
  if (token) {
    base64Url = await JSON.parse(global.atob(tokenArr[1]));
  }
  console.log({ token });
  LocalStorageUtils.setItem("auth_token", token);
  return base64Url;
};

export const DateFormatter = (dateString: any, dateFormat: any) => {
  return moment(dateString).format(dateFormat);
};

export const findItemIndex = (arr: any, id: any) => {
  let index = findIndex(
    arr,
    (obj: any) => {
      return obj.id == id;
    },
    0
  );

  return index;
};

export const checkIfDateIsGreaterThanToday = (GivenDate: string) => {
  var CurrentDate = new Date();
  var given = new Date(GivenDate);
  if (given > CurrentDate) {
    return true;
  } else {
    return false;
  }
};

export const capitalizeFirstLetter = (s: string) => {
  if (s) {
    const string = startCase(toLower(s));
    // return s[0].toUpperCase() + s.slice(1).toLowerCase();
    return string;
  } else {
    return "";
  }
};

export const addDotOnBigLine = (text: string, len: number) => {
  len = len ? len : 26;
  if (text?.length > 26) {
    var shortname = text.substring(0, len) + "...";
    return shortname;
  }
  return text;
};

export function isEmptyOrSpaces(str: string) {
  return str === null || str.match(/^ *$/) !== null;
}

export const getMessageTimestamp = (timestamp: string) => {
  const now = moment();
  const messageTime = moment(timestamp);
  const diff = now.diff(messageTime, "minutes");
  if (diff < 1) {
    return "Just now";
  } else if (diff < 60) {
    return `${diff === 1 ? "A minute ago" : `${diff} minutes ago`}`;
  } else if (diff < 1440) {
    return `${Math.floor(diff / 60) === 1 ? "An hour ago" : `${Math.floor(diff / 60)} hours ago`}`;
  } else if (diff < 10080) {
    return `${Math.floor(diff / 1440)} ${Math.floor(diff / 1440) === 1 ? "day ago" : "days ago"}`;
  } else {
    return messageTime.format("MMMM Do YYYY, hh:mm a");
  }
};

export const getYearsFromMonths = (months: number) => {
  const years = Math.floor(months / 12);
  let range;
  if (years === 0) {
    range = "0 - 1 years";
  } else if (years === 1) {
    range = "1 year";
  } else {
    range = `${years}+ years`;
  }
  return range;
};

export const openImageInBrowser = (image: any) => {
  window.open(image, "_blank");
};
